import { render, staticRenderFns } from "./GraphDetail81.vue?vue&type=template&id=bbd99afa&scoped=true"
import script from "./GraphDetail81.vue?vue&type=script&lang=js"
export * from "./GraphDetail81.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd99afa",
  null
  
)

export default component.exports